import { pick } from 'lodash';
import { childFields } from './childFields';

export const journalChildDTOFields = {
    ...pick(childFields, ['id', 'firstName', 'lastName', 'sex', 'groups', 'parents', 'address']),
    joinDate: 'joinDate',
    leaveDate: 'leaveDate',
} as const;
